import {useEffect} from "react";
import Modal from "react-bootstrap/Modal";
import {useTranslation} from "react-i18next";
import moment from "moment";

import {PRODUCTS} from "site-apps/productListModels";

const ModalLogs = ({showAlert, setShowAlert, itemSelected}) => {
    const [_Tt] = useTranslation("tables");
    const [_Tc] = useTranslation("choices");

    const handleClose = () => {
        setShowAlert(false);
    };

    return (
        <Modal show={showAlert} onHide={handleClose} size="lg" animation={true} centered={true} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title className="w-100">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>{itemSelected.uuid}</div>
                        <div className="text-secondary" style={{fontSize: "0.9rem"}}>
                            <span>{moment(itemSelected.time).format("DD-MM-YYYY HH:mm:ss")}</span>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="container-fluid">
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <strong>Cliente:</strong> {itemSelected.client}
                        </div>
                        <div className="col-md-6 text-end">
                            <strong>
                                {itemSelected.product} - {PRODUCTS[itemSelected.product] || itemSelected.product}
                            </strong>
                        </div>
                        <div className="col-md-6">
                            <strong>Tipo:</strong> {_Tc("messages_log." + itemSelected.type)}
                        </div>
                        <div className="col-md-6 text-end">
                            <strong>0x{itemSelected.code}</strong>
                        </div>
                        <div className="col-md-12">
                            <strong>Error:</strong> {itemSelected.error || "N/A"}
                        </div>
                    </div>

                    <div className="row mb-3">
                        <hr />
                        <div className="col-12">
                            <pre
                                className="bg-light p-2 rounded"
                                style={{
                                    fontSize: "0.85rem",
                                    whiteSpace: "pre-wrap",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                }}>
                                {itemSelected.data}
                            </pre>
                        </div>
                    </div>

                    <div className="row">
                        <hr />
                        <div className="col-12">
                            <pre
                                className="bg-light p-3 rounded"
                                style={{maxHeight: "400px", overflow: "auto", fontSize: "0.85rem"}}>
                                {JSON.stringify(itemSelected.json, null, 2)}
                            </pre>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ModalLogs;
